/*LIBRARY*/
import { connect } from "react-redux";

/*COMPONENT*/
import { Dropdown } from "../reuseable";

/*REDUX*/
import { set_value_properties } from "../../App/actions/propertiesActions";

/*PICTURE*/
import referrence_2d_file from "../../Assets/file/[2d-referrence]-[comma-delimited-UTF8].csv";
import useLanguage from "../common_hooks/useLanguage";
import PreviewReferrenceData2D from "../common_field/PreviewReferrenceData2D";
import { handle_upload_csv } from "../../App/validation/handle_file";

/*FUNCTION*/

/*DATA*/
// import dict from "../../Data/dict.json";

/*CONST*/

const SET_2DR = ({
  //variable
  auth,
  layer,
  properties,

  //function
  set_value_properties,
}) => {
  //localStorage
  const { language, dict } = useLanguage();

  //state & ref

  //global props
  const { field_editable } = properties;
  const { reference_list_2d } = field_editable || {};
  const { geo_layer_list, layer_id } = layer;

  //variables
  const geo_layer = geo_layer_list.find(
    (item) => item?.geo_layer?._id === layer_id
  )?.geo_layer;
  const fields = geo_layer?.fields || [];

  //functions
  const handleCsvValidation2dReferring = async (e) => {
    const file = await handle_upload_csv(e);
    const headers = file?.headers;
    let is_valid = "invalid";

    if (headers?.includes("index_name")) {
      is_valid = "valid";
    }
    if (is_valid === "valid") {
      let new_result = reference_list_2d;
      new_result["headers"] = headers;
      new_result["features"] = file.data;
      set_value_properties({
        key: "field_editable",
        value: {
          ...field_editable,
          reference_list_2d: new_result,
        },
      });
    }
  };

  const handleSelect = (value, attribute_name) => {
    const enum_value = ["row_name", "column_name"];
    const is_valid = enum_value.includes(attribute_name);
    if (!is_valid) return;

    let new_ref = { ...reference_list_2d } || {};
    new_ref[attribute_name] = value;
    set_value_properties({
      key: "field_editable",
      value: {
        ...field_editable,
        reference_list_2d: new_ref,
      },
    });
  };

  return (
    <main>
      <h1 className="text_bold margin_bottom">Pengaturan 2D Reference</h1>

      <div className="container background_grey_light outline_grey">
        <div>
          <label className="font_18 w_full">2D Referring</label>
          <div className="flex gap_10 paddingTop_10">
            <a
              className="button_big background_black"
              href={referrence_2d_file}
            >
              <div className="center_perfect w_full h_full">
                {dict?.["Download CSV Template"]?.[language]}
              </div>
            </a>

            <label className="inline">
              <div className="button_big background_black">
                {dict["Upload CSV"][language]}
              </div>
              <input
                style={{ display: "none" }}
                type="file"
                accept=".csv*"
                onChange={handleCsvValidation2dReferring}
              />
            </label>
            {reference_list_2d?.features?.length > 0 && (
              <PreviewReferrenceData2D data={reference_list_2d} />
            )}
          </div>

          <div className="two_container_equal">
            <div>
              <label className="text_medium sub_color">
                {
                  dict[
                  "Select column name from main table that will refer as a row in secondary table"
                  ][language]
                }
              </label>

              <Dropdown
                placeholder={dict["Select"][language]}
                filter_on
                is_enable_empty
                value={reference_list_2d?.["row_name"]}
                onChange={(value) => {
                  handleSelect(value, "row_name");
                }}
              >
                {fields.map((header) => {
                  return (
                    <option key={header?.key} value={header?.key}>
                      {header.name}
                    </option>
                  );
                })}
              </Dropdown>
            </div>

            <div>
              <label className="text_medium sub_color">
                {
                  dict[
                  "Select column name from main table that will refer as a column in secondary table"
                  ][language]
                }
              </label>

              <Dropdown
                placeholder={dict["Select"][language]}
                filter_on
                is_enable_empty
                value={reference_list_2d?.["column_name"]}
                onChange={(value) => {
                  handleSelect(value, "column_name");
                }}
              >
                {fields.map((header) => {
                  return (
                    <option key={header?.key} value={header?.key}>
                      {header.name}
                    </option>
                  );
                })}
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  properties: state.properties,
});

export default connect(mapStateToProps, { set_value_properties })(SET_2DR);
